module.exports = __webpack_public_path__ + "img/Logotipo_Interno.57d500fd.svg";